import { MygrowIcon } from "@/components/brand/MygrowLogo";
import { cn } from "@/lib/utils";

/**
 * O que o logo faz no fim do log: `working` anima sem parar (o agente trabalha),
 * `pulse` pula uma vez (chegou item novo) e `still` fica parado e apagado (conversa
 * encerrada, sem execução ou conexão perdida).
 */
export type TerminalLogoMotion = "working" | "pulse" | "still";

const MOTION_CLASS: Record<TerminalLogoMotion, string> = {
  working: "motion-safe:animate-mygrow-nudge",
  // Mesmo keyframe do `mygrow-nudge`, uma única volta.
  pulse: "motion-safe:animate-[mygrow-nudge_0.7s_ease-in-out_1]",
  still: "opacity-40",
};

/**
 * O logo do GROW no fim do log do terminal. Toda animação é `motion-safe`: com
 * `prefers-reduced-motion` ele fica parado nos três estados.
 *
 * `pulseSeq` é o `seq` do último item do log (ou da última linha dele). Trocar a `key`
 * do elemento reinicia a animação CSS de uma volta, sem estado nem temporizador; em
 * `working` e `still` a `key` não muda, para o laço não reiniciar a cada linha.
 */
export function TerminalLogo({
  motion,
  pulseSeq,
}: {
  motion: TerminalLogoMotion;
  pulseSeq: number;
}) {
  return (
    <MygrowIcon
      key={motion === "pulse" ? `pulse-${pulseSeq}` : motion}
      title={null}
      data-testid="terminal-logo"
      data-motion={motion}
      data-pulse={motion === "pulse" ? pulseSeq : undefined}
      className={cn("h-5 w-5 shrink-0 text-white", MOTION_CLASS[motion])}
    />
  );
}
